
import React from 'react';

function Sidebar() {
  return (
    <div className="w-64 bg-white shadow-md h-full">
      <div className="p-6 font-bold text-xl border-b">PEACO Admin</div>
      <ul className="p-4 space-y-2">
        <li className="text-blue-600 font-semibold">Accounts</li>
        <li className="text-gray-600">Claims</li>
        <li className="text-gray-600">Reports</li>
      </ul>
    </div>
  );
}

export default Sidebar;
